import React from 'react';
import moment from 'moment';
import { Button, Form, Modal } from 'react-bootstrap';

interface PriceInDateObject {
  total: number,
  total_planets: number,
  planet_eur: number,
  planet_usd: number,
  coin: string,
}

interface Props {
  t: any,
  calcCovertion: Function,
  showPriceHistory: any,
  hidePriceInDate: () => void,
  title: string,
  setPriceDate: any,
  priceInDate: PriceInDateObject | undefined,
  getCurrency: () => void,

}

const PriceInDateModal = (props: Props) => {
  return (
        <>
        <Modal show={props.showPriceHistory} onHide={props.hidePriceInDate} backdrop='static' keyboard={false} size='xl'>
          <Modal.Header closeButton>
            <Modal.Title>{props.title}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form.Group className='mb-3' controlId='formBasicPassword'>
              <Form.Label>{props.t('DATE')}</Form.Label>
              <Form.Control type='date' defaultValue={moment(new Date()).format('YYYY-MM-DD')}
                onChange={(e: any) => {
                  props.setPriceDate(e.target.valueAsDate);
                }} />
            </Form.Group>
            {
              props.priceInDate &&
              <Form.Group className='mb-3' controlId='formBasicPassword'>
                <table>
                  <tbody>
                    <tr>
                      <th>{props.t('TOTAL')}: </th>
                      <td>
                        {props.priceInDate?.total || '-'} {props.getCurrency()}
                      </td>
                    </tr>
                    <tr>
                      <th>{props.t(`TOTAL_${props.priceInDate?.coin}`)}: </th>
                      <td>{props.priceInDate?.total_planets || '-'} {props.priceInDate?.coin}</td>
                    </tr>
                    <tr>
                      <th>{props.t(`${props.priceInDate?.coin}/EUR`)}: </th>
                      <td>{props.priceInDate?.planet_eur || '-'} €</td>
                    </tr>
                    <tr>
                      <th>{props.t(`${props.priceInDate?.coin}/USD`)}: </th>
                      <td>{props.priceInDate?.planet_usd || '-'} $</td>
                    </tr>
                  </tbody>
                </table>
              </Form.Group>
            }

          </Modal.Body>

          <Modal.Footer>
            <Button variant='secondary' onClick={props.hidePriceInDate}>
              {props.t('CANCEL')}
            </Button>
            <Button variant='primary' onClick={() => {
              props.calcCovertion(props.showPriceHistory.currentPaymentType).then(() => { });
            }}>
              {props.t('SEARCH')}
            </Button>
          </Modal.Footer>
        </Modal>
        </>
  );
};

export default PriceInDateModal;